/* eslint-disable @typescript-eslint/no-explicit-any */
import { useField } from 'formik';
import { FormControl, TextField } from '@mui/material';
import { FORM_MODES } from '@innovyze/stylovyze/lib/utils/constants';
import { ItemWithLabel } from '@innovyze/stylovyze/lib/components/Items';
import React from 'react';
import useGetCombinedEvents from './hooks/useGetCombinedEvents';
import { useMode } from './contexts/StylovyzeFormContext';
export default function InputText(props) {
    const { fieldAttrs, textField, dataCy, networkError } = props;
    const mode = useMode();
    const [field] = useField(fieldAttrs);
    const combinedEvents = useGetCombinedEvents({
        fieldAttrs,
        onChange: props.onChange,
        onDebounceChange: props.onDebounceChange,
        networkError,
        onFocus: textField.onFocus,
        onBlur: textField.onBlur,
    });
    const getValue = (value = '') => {
        return value;
    };
    return (React.createElement(FormControl, { variant: "standard", fullWidth: true }, mode === FORM_MODES.VIEW ? (React.createElement(ItemWithLabel, { label: textField.label, value: textField.value || field.value })) : (React.createElement(TextField, { className: props.className, variant: textField.variant || 'outlined', margin: textField.margin || 'normal', color: textField.color || 'primary', inputProps: { contentEditable: false }, "data-cy": dataCy, name: field.name, value: getValue(field.value), ...textField, onChange: combinedEvents.onChange, onBlur: combinedEvents.onBlur, onFocus: combinedEvents.onFocus }))));
}
